module.exports = __webpack_public_path__ + "static/74bcea65-26a6-450f-86df-75f1dd0727d5-42c705d2daa7cff565ffcb422f4e9f5e.webp";